import { atom } from 'jotai';

interface ILedgerConnect {
  isConnectOpened?: boolean;
  isSignTxOpened?: boolean;
  isSignMessageOpened?: boolean;
  unsignedTx?: string;
  message?: string;
  onSignSuccess?: (signature: string) => any;
}

export const ledgerDialogAtom = atom<ILedgerConnect | null>(null);
